import { render, staticRenderFns } from "./TextVoiceThen.vue?vue&type=template&id=46762e8b&scoped=true"
import script from "./TextVoiceThen.vue?vue&type=script&lang=js"
export * from "./TextVoiceThen.vue?vue&type=script&lang=js"
import style0 from "./TextVoiceThen.vue?vue&type=style&index=0&id=46762e8b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46762e8b",
  null
  
)

export default component.exports